module.exports = __webpack_public_path__ + "img/potion_20.5cc356a9.png";